<div class="videoconsulta-container container-fluid vc-shell p-0">

  <div class="row bg-white border-bottom py-2 px-3 w-100 vc-header">

    <div class="col p-1">

      <h4
        class="font-weight-bold pb-2"
        style="font-family:'Mulish';color:#1a237e;font-size:24px;font-weight:800;margin:0;">
        Tu consulta con:
      </h4>

      <h5
        class="pb-1"
        style="font-family:'Mulish';color:#1a237e;font-size:18px;font-weight:700;margin:0!important;">

        {{consulta.nombre_paciente}}
        {{consulta.apellido_paterno_paciente}}
        {{consulta.apellido_materno_paciente}}

      </h5>

    </div>

    <div
      class="btn-box"
      role="group">

      <span class="vista-label">

        <mat-icon class="mr-1">
          dashboard
        </mat-icon>

        Vista:

      </span>

      <button
        class="btn btn-vista"
        [ngClass]="{'active': selectedView === 'consulta'}"
        (click)="changeView('consulta')">

        Consulta actual

      </button>

      <button
        class="btn btn-vista d-none d-xl-inline-block"
        [ngClass]="{'active': selectedView === 'video'}"
        (click)="changeView('video')">

        Video con paciente

      </button>

      <button
        class="btn btn-vista"
        [ngClass]="{'active': selectedView === 'paciente'}"
        (click)="changeView('paciente')">

        Información del paciente

      </button>

    </div>

  </div>

  <div class="row m-0 vc-main">

    <div
      [ngClass]="{
        'col-xl-12 col-md-12 p-1': selectedView === 'video',
        'col-xl-5 col-md-12 p-1 d-flex flex-column': selectedView !== 'video'
      }"
      style="gap:10px;overflow:auto;">

      <app-video-web-rtc
        #WEB_RTC
        [video_iniciado]="videoIniciado"
        [video_finalizada]="videoFinalizada"
        (toggleView)="onToggleViewFromVideo()"
        (connectionLog)="onWebRtcLog($event)"
        (mediaPermissionError)="onMediaError($event)">
      </app-video-web-rtc>

      <!-- BOTONES -->
      <div
        class="m-0 d-flex justify-content-between"
        style="gap:5px;"
        [ngStyle]="
          selectedView === 'video'
            ? {'flex-direction':'row'}
            : {'flex-direction':'column'}
        ">

        <button
          *ngIf="videoIniciado"
          class="btn btn-primary btn-finalizar w-100 mr-2"
          (click)="finalizarVideollamada()">

          Finalizar videollamada

        </button>

        <button
          *ngIf="mostrarBotonFinalizarConsulta"
          class="btn btn-primary btn-white w-100"
          (click)="verificacionFinalizar()">

          Finalizar consulta

        </button>

        <button
          *ngIf="mostrarBotonIniciarVideollamada"
          class="btn btn-primary btn-iniciar w-100"
          [disabled]="!btnIniciar"
          (click)="iniciarVideollamada()">

          {{
            videollamadaYaIniciada
              ? 'Reiniciar videollamada'
              : 'Iniciar videollamada'
          }}

        </button>

        <button
          *ngIf="mostrarBotonAnularConsulta"
          class="btn btn-primary btn-white w-100"
          (click)="mostrarModal('salir')">

          Problema videollamada

        </button>

      </div>

      <div class="vc-scroll-sm shadow-sm">

        <div class="card m-0">

          <div
            class="text-muted card-header p-3 d-flex align-items-center justify-content-between"
            style="background-color:white;cursor:pointer;"
            role="button"
            data-toggle="collapse"
            data-target="#infoCollapse"
            aria-expanded="false"
            aria-controls="infoCollapse">

            <h6
              class="mb-0 d-flex align-items-center"
              style="color:#808080!important;font-weight:600;">

              <i class="fi fi-rr-document"></i>

              <span
                class="p-0"
                style="font-family:'Mulish';font-size:14px;">
                Motivo de consulta
              </span>

            </h6>

            <span class="collapse-arrow d-inline-flex align-items-center">

              <i class="fi fi-rr-angle-small-down arrow-down"></i>

              <i class="fi fi-rr-angle-small-up arrow-up"></i>

            </span>

          </div>

          <div
            id="infoCollapse"
            class="collapse">

            <div
              class="card-body"
              style="box-shadow:0 .125rem .25rem rgba(0,0,0,.15)!important;font-family:'Mulish';">

              {{consulta.razon}}

            </div>

          </div>

        </div>

      </div>

      <div
        class="vc-scroll shadow-sm"
        *ngIf="selectedView === 'paciente'">

        <ng-container
          *ngTemplateOutlet="consultaView">
        </ng-container>

      </div>

      <div
        class="vc-scroll shadow-sm"
        *ngIf="selectedView === 'consulta'">

        <ng-container
          *ngTemplateOutlet="pacienteView">
        </ng-container>

      </div>

    </div>

    <div
      class="col-xl-7 p-1"
      *ngIf="selectedView !== 'video'">

      <div class="vc-scroll shadow-sm">

        <ng-container
          *ngIf="selectedView === 'consulta'">

          <ng-container
            *ngTemplateOutlet="consultaView">
          </ng-container>

        </ng-container>

        <ng-container
          *ngIf="selectedView === 'paciente'">

          <ng-container
            *ngTemplateOutlet="pacienteView">
          </ng-container>

        </ng-container>

      </div>

    </div>

  </div>

</div>


<!-- ======================================================
     CONSULTA VIEW
====================================================== -->

<ng-template #consultaView>

  <div
    class="bg-white shadow-sm rounded p-3 h-100 m-0 animated-fade">

    <div
      class="text-muted mb-2"
      style="display:flex;align-items:center;">

      <i class="d-flex fi fi-rr-digital-tachograph"></i>

      <span>
        Consulta actual
      </span>

    </div>

    <ul
      class="nav nav-pills mb-3 nav-justified"
      role="tablist"
      style="gap:10px;">

      <li class="nav-item">

        <a
          class="nav-link active custom-tab"
          data-toggle="pill"
          href="#consulta"
          role="tab"
          [ngClass]="{'active-tab': activeConsultaTab === 'consulta'}"
          (click)="activeConsultaTab = 'consulta'; selectedView = 'consulta'">

          Consulta Actual

        </a>

      </li>

      <li class="nav-item">

        <a
          class="nav-link custom-tab"
          data-toggle="pill"
          href="#agenda"
          role="tab"
          [ngClass]="{'active-tab': activeConsultaTab === 'agenda'}"
          (click)="activeConsultaTab = 'agenda'; selectedView = 'consulta'">

          Consultas de hoy

        </a>

      </li>

    </ul>

    <div class="tab-content p-0">

      <div
        class="tab-pane fade show active"
        id="consulta"
        role="tabpanel"
        *ngIf="activeConsultaTab === 'consulta'">

        <app-documentos-consulta
          *ngIf="consulta?.id_consulta"
          [consulta]="consulta"
          [selectedView]="selectedView"
          [selectedTab]="selectedDocTab"
          (selectedViewChange)="selectedView = $event"
          (selectedTabChange)="onSelectedTabFromDocumentos($event)">
        </app-documentos-consulta>

      </div>

      <div
        class="tab-pane fade show active"
        id="agenda"
        [ngClass]="{'pantalla-sm': selectedView !== 'consulta'}"
        role="tabpanel"
        *ngIf="activeConsultaTab === 'agenda'">

        <app-agenda-doctor
          *ngIf="consulta?.id_consulta"
          [consulta]="consulta"
          [selectedView]="selectedView">
        </app-agenda-doctor>

      </div>

    </div>

  </div>

</ng-template>


<!-- ======================================================
     PACIENTE VIEW
====================================================== -->

<ng-template #pacienteView>

  <div
    class="col d-flex"
    *ngIf="isLoading"
    style="min-height:60px;height:100%!important;">

    <div class="loader">

      <div class="loader__figure"></div>

      <p class="loader__label"></p>

    </div>

  </div>

  <ng-container *ngIf="!isLoading">

    <div
      class="bg-white shadow-sm rounded p-3 h-100 m-0 animated-fade">

      <div
        class="text-muted mb-2"
        style="display:flex;align-items:center;">

        <i class="d-flex fi fi-rr-digital-tachograph"></i>

        <span>
          Información del paciente
        </span>

      </div>

      <div class="d-flex align-items-center mb-2">

        <div
          class="rounded-circle overflow-hidden mr-3"
          style="width:60px;height:60px;background-color:#f1f1f1;">

          <img
            *ngIf="consulta?.foto"
            [src]="consulta.foto"
            class="img-fluid"
            style="object-fit:cover;width:100%;height:100%;" />

          <app-profile-img
            [img]="img_paciente"
            [doctorName]="consulta.nombre_paciente"
            [doctorLastName]="consulta.apellido_paterno_paciente">
          </app-profile-img>

        </div>

        <div style="width:-webkit-fill-available;">

          <div
            class="font-weight-bold"
            style="font-size:18px;font-family:'Mulish';">

            {{consulta?.nombre_paciente}}
            {{consulta.apellido_paterno_paciente}}

          </div>

          <div
            class="row text-muted"
            style="font-size:14px;gap:0;display:flex;">

            <div
              class="col-12"
              style="display:flex;gap:5px;align-items:center;font-size:12px;">

              <span
                style="display:flex;align-items:center;gap:2px;">

                <i class="d-flex fi fi-rr-phone-call"></i>

                {{consulta?.telefono_paciente}}

              </span>

            </div>

            <div
              class="col-12"
              style="display:flex;gap:5px;align-items:center;font-size:12px;">

              <span
                style="display:flex;align-items:center;gap:2px;">

                <i class="d-flex fi fi-rr-envelope"></i>

                {{consulta?.mail_paciente}}

              </span>

            </div>

          </div>

        </div>

      </div>

      <hr style="margin:10px 0;">

      <ng-container
        *ngIf="selectedView === 'paciente'">

        <div
          class="row text-center text-md-left font-weight-bold small">

          <div class="mb-1 col-6">

            <div
              class="text-muted"
              style="display:flex;align-items:center;">

              <i class="d-flex fi fi-rr-id-badge"></i>

              RUT

            </div>

            <p
              class="p-0"
              style="font-family:'Mulish';text-align:start;">

              {{consulta?.rut_paciente}}

            </p>

          </div>

          <div class="mb-1 col-6">

            <div
              class="text-muted"
              style="display:flex;align-items:center;">

              <i class="d-flex fi fi-rr-calendar"></i>

              Edad

            </div>

            <p
              class="p-0"
              style="font-family:'Mulish';text-align:start;">

              {{consulta?.edad}}

            </p>

          </div>

          <div class="mb-1 col-6">

            <div
              class="text-muted"
              style="display:flex;align-items:center;">

              <i class="d-flex fi fi-rr-marker"></i>

              Ubicación

            </div>

            <p
              class="p-0"
              style="font-family:'Mulish';text-align:start;">

              {{consulta?.com_name}},
              {{consulta.reg_name}}

            </p>

          </div>

        </div>

      </ng-container>

      <ul
        class="nav nav-pills botones my-3 justify-content-around p-0 rounded-pill">

        <li class="nav-item">

          <a
            class="nav-link d-flex align-items-center rounded-pill px-1"
            [ngClass]="{
              'active-tab':
                activePacienteTab === 'antecedentes' &&
                selectedView === 'paciente'
            }"
            (click)="activePacienteTab = 'antecedentes'; selectedView = 'paciente'">

            <i class="d-flex fi fi-rr-user"></i>

            <span>
              Antecedentes
            </span>

          </a>

        </li>

        <li class="nav-item">

          <a
            class="nav-link d-flex align-items-center rounded-pill px-1"
            [ngClass]="{
              'active-tab':
                activePacienteTab === 'consultasprevias'
            }"
            (click)="activePacienteTab = 'consultasprevias'; selectedView = 'paciente'">

            <i class="d-flex fi fi-rr-time-past"></i>

            <span>
              Consultas previas
            </span>

          </a>

        </li>

        <li class="nav-item">

          <a
            class="nav-link d-flex align-items-center rounded-pill px-1"
            [ngClass]="{
              'active-tab':
                activePacienteTab === 'documentos' &&
                selectedView === 'paciente'
            }"
            (click)="activePacienteTab = 'documentos'; selectedView = 'paciente'">

            <i class="d-flex fi fi-rr-document"></i>

            <span>
              Documentos
            </span>

          </a>

        </li>

      </ul>

      <div class="tab-content">

        <div
          id="antecedentes"
          class="tab-pane fade show active"
          *ngIf="activePacienteTab === 'antecedentes'">

          <app-antecedentes-medicos
            [consulta]="consulta"
            *ngIf="selectedView === 'paciente' || selectedView === 'video'">
          </app-antecedentes-medicos>

        </div>

        <div
          id="consultasprevias"
          class="tab-pane fade show active"
          *ngIf="activePacienteTab === 'consultasprevias'">

          <app-consultas-previas2
            [consulta]="consulta"
            [selectedView]="selectedView"
            [ngClass]="{'pantalla-sm': selectedView !== 'paciente'}">
          </app-consultas-previas2>

        </div>

        <div
          id="documentos"
          class="tab-pane fade show active"
          *ngIf="activePacienteTab === 'documentos'">

          <app-documentos-previos
            [consulta]="consulta"
            *ngIf="selectedView === 'paciente' || selectedView === 'video'">
          </app-documentos-previos>

        </div>

      </div>

    </div>

  </ng-container>

</ng-template>


<!-- ======================================================
     PROBLEMA / ANULACIÓN
====================================================== -->

<div
  class="modal-backdrop-common"
  *ngIf="modalActual === 'salir'"
  (click)="cerrarModal()">

  <div
    class="modal-common-content"
    (click)="$event.stopPropagation()">

    <h2 class="modal-title">
      Problema de videollamada
    </h2>

    <p class="modal-reason">
      Indique el problema que está presentando para registrar incidencia.
    </p>

    <form
      [formGroup]="anularConsultaForm">

      <div class="form-group">

        <!-- MOTIVO -->
        <label
          for="motivo_finalizacion"
          style="font-family:'Mulish';font-size:14px;font-weight:600;color:#171994;">

          Tipo de problema:

        </label>

        <select
          id="motivo_finalizacion"
          class="form-control"
          formControlName="motivo">

          <option
            [ngValue]="null"
            disabled>

            Selecciona una opción

          </option>

          <option
            *ngFor="let razon of cancelReason"
            [ngValue]="razon.id_reason">

            {{razon.reason_name}}

          </option>

        </select>

        <small
          class="text-danger"
          *ngIf="
            anularConsultaForm.get('motivo')?.invalid &&
            anularConsultaForm.get('motivo')?.touched
          ">

          Debes seleccionar una opción.

        </small>


        <!-- DESCRIPCIÓN OPCIONAL -->
        <div class="mt-3">

          <label
            for="end_description"
            style="font-family:'Mulish';font-size:14px;font-weight:600;color:#171994;">

            Descripción

            <span
              style="font-weight:400;color:#808080;">

              (opcional)

            </span>

          </label>

          <textarea
            id="end_description"
            class="form-control"
            formControlName="end_description"
            rows="4"
            placeholder="Ingresa información adicional sobre el problema...">
          </textarea>

        </div>

      </div>

    </form>

    <div class="buttons-box row mt-3">

      <div class="col">

        <button
          mat-button
          class="btn-secondary"
          style="line-height:36px;"
          (click)="cerrarModal()">

          <p
            class="m-0"
            style="font-weight:600;">

            Cancelar

          </p>

        </button>

      </div>

      <div class="col">

        <button
          mat-raised-button
          class="btn-primary-cancel2"
          style="line-height:36px;"
          [disabled]="anularConsultaForm.invalid"
          (click)="continuarAnulacion()">

          <p
            class="m-0"
            style="font-weight:600;">

            Registrar problema

          </p>

        </button>

      </div>

    </div>

  </div>

</div>


<!-- ======================================================
     RESUMEN FICHA
====================================================== -->

<div
  class="modal-backdrop fade show"
  *ngIf="modalActual === 'finalizarFicha'"
  (click)="volverDesdeResumen()">
</div>

<div
  class="modal ModalFinalizarConsulta p-0"
  [ngClass]="{'show d-block': modalActual === 'finalizarFicha'}"
  tabindex="-1"
  role="dialog"
  [attr.aria-hidden]="
    modalActual === 'finalizarFicha'
      ? 'false'
      : 'true'
  "
  style="background-color:rgba(0,0,0,.5);">

  <div
    class="modal-dialog"
    role="document"
    style="height:-webkit-fill-available;display:flex;align-items:center;">

    <div
      class="modal-content"
      style="border:none;border-radius:10px;">

      <div class="modal-header">

        <h2 style="text-align:center;">
          Resumen de ficha médica
        </h2>

      </div>

      <div class="modal-body">

        <p
          style="
            font-family:Mulish;
            font-weight:700;
            font-size:18px;
            line-height:24px;
            color:#171994;
          ">

          Los siguientes documentos fueron generados:

        </p>

        <div
          class="card"
          style="align-items:center;">

          <div>

            <input
              *ngIf="archivos_consulta.diagnostics.length > 0"
              id="diag_id"
              class="filled-in checkbox-css"
              type="checkbox"
              checked
              disabled>

            <input
              *ngIf="archivos_consulta.diagnostics.length < 1"
              id="diag_id"
              class="filled-in checkbox-css"
              type="checkbox"
              disabled>

            <label
              for="diag_id"
              class="texto-checkbox">
              Diagnóstico e indicaciones
            </label>

            <br>

            <input
              *ngIf="archivos_consulta.prescriptions.length > 0"
              id="pre_id"
              class="filled-in checkbox-css"
              type="checkbox"
              checked
              disabled>

            <input
              *ngIf="archivos_consulta.prescriptions.length < 1"
              id="pre_id"
              class="filled-in checkbox-css"
              type="checkbox"
              disabled>

            <label
              for="pre_id"
              class="texto-checkbox">
              Receta médica
            </label>

            <br>

            <input
              *ngIf="archivos_consulta.certificados.length > 0"
              id="cert_id"
              class="filled-in checkbox-css"
              type="checkbox"
              checked
              disabled>

            <input
              *ngIf="archivos_consulta.certificados.length < 1"
              id="cert_id"
              class="filled-in checkbox-css"
              type="checkbox"
              disabled>

            <label
              for="cert_id"
              class="texto-checkbox">
              Certificado médico
            </label>

            <br>

            <input
              *ngIf="archivos_consulta.orders.length > 0"
              id="ord_id"
              class="filled-in checkbox-css"
              type="checkbox"
              checked
              disabled>

            <input
              *ngIf="archivos_consulta.orders.length < 1"
              id="ord_id"
              class="filled-in checkbox-css"
              type="checkbox"
              disabled>

            <label
              for="ord_id"
              class="texto-checkbox">
              Órdenes de exámenes
            </label>

            <br>

            <input
              *ngIf="documentos_consulta?.length > 0"
              id="docs_id"
              class="filled-in checkbox-css"
              type="checkbox"
              checked
              disabled>

            <input
              *ngIf="!documentos_consulta || documentos_consulta.length < 1"
              id="docs_id"
              class="filled-in checkbox-css"
              type="checkbox"
              disabled>

            <label
              for="docs_id"
              class="texto-checkbox">
              Documentos adjuntos
            </label>

            <br>

          </div>

        </div>


        <!-- INFORMACIÓN DE LA ANULACIÓN -->
        <div
          *ngIf="finalizacionDesdeAnulacion"
          class="mt-3">

          <p
            style="
              font-family:Mulish;
              font-size:16px;
              text-align:center;
              margin-bottom:5px;
            ">

            Motivo seleccionado:

          </p>

          <p
            style="
              font-family:Mulish;
              font-size:16px;
              font-weight:700;
              text-align:center;
              color:#171994;
            ">

            {{getMotivoAnulacionSeleccionado()}}

          </p>

          <ng-container
            *ngIf="getDescripcionFinalizacion()">

            <p
              style="
                font-family:Mulish;
                font-size:16px;
                text-align:center;
                margin-bottom:5px;
                margin-top:15px;
              ">

              Descripción:

            </p>

            <p
              style="
                font-family:Mulish;
                font-size:15px;
                text-align:center;
                color:#555;
                white-space:pre-wrap;
              ">

              {{getDescripcionFinalizacion()}}

            </p>

          </ng-container>

        </div>

        <!-- MENSAJE CUANDO LA FINALIZACIÓN VIENE DESDE "PROBLEMA VIDEOLLAMADA" -->
<ng-container *ngIf="finalizacionDesdeAnulacion">

  <!-- PACIENTE NO ASISTE -->
  <p
    *ngIf="typeEndSeleccionado === 2"
    style="
      font-family:Mulish;
      font-size:16px;
      line-height:24px;
      text-align:center;
      color:#000;
    ">
    Al confirmar el cierre de esta consulta se enviará una notificación al paciente señalando que la videollamada no pudo completarse y que <b>esta consulta será descontada de su plan.</b>
    Podrás revisar el detalle desde el historial de consultas.
  </p>

  <!-- CUALQUIER OTRO MOTIVO -->
  <p
    *ngIf="typeEndSeleccionado === 3"
    style="
      font-family:Mulish;
      font-size:16px;
      line-height:24px;
      text-align:center;
      color:#000;
    ">
    Al confirmar el cierre de esta consulta se enviará una notificación al paciente señalando que la videollamada no pudo completarse y que <b>esta consulta no será descontada de su plan.</b>
    Podrás revisar el detalle desde el historial de consultas.
  </p>

</ng-container>

<!-- FINALIZACIÓN NORMAL -->
<p
  *ngIf="!finalizacionDesdeAnulacion"
  style="
    font-family:Mulish;
    font-size:16px;
    line-height:24px;
    text-align:center;
    color:#000;
  ">
  Al confirmar la finalización de la consulta <b>se enviará una notificación al paciente</b> señalando que los resultados han sido correctamente agregados.
  Recuerda que <b>siempre podrás modificar los resultados</b> desde el historial de consultas.
</p>

      </div>

      <div class="modal-footer buttons-box">

        <div style="width:50%;">

          <button
            type="button"
            class="btn-secondary"
            style="line-height:36px;"
            (click)="volverDesdeResumen()">

            <div style="margin:auto;">
              Volver
            </div>

          </button>

        </div>

        <div style="width:50%;">

          <button
            class="btn-primary-cancel"
            (click)="finalizarConsultaDesdeResumen()"
            style="line-height:36px;border:2px solid #0e0087!important;">

            <div style="margin:auto;">
              Finalizar consulta
            </div>

          </button>

        </div>

      </div>

    </div>

  </div>

</div>


<!-- ======================================================
     INSTRUCCIONES VIDEOLLAMADA
====================================================== -->

<ng-template #modalInstruccionesTpl>

  <div style="overflow:auto;">

    <div
      class="modal-instrucciones-doctor-contenido"
      (click)="$event.stopPropagation()">

      <h4 class="tituloModalConfirmar">

        <span class="emoji">
          🔔
        </span>

        <span class="texto">
          Antes de comenzar tu videollamada
        </span>

      </h4>

      <p class="descripcionModal">

        Para asegurar una atención médica sin interrupciones,
        te pedimos
        <strong>verificar lo siguiente:</strong>

      </p>

      <div class="listaModal">

        <div class="itemModal">
          📶 Contar con una conexión a Internet rápida y estable.
        </div>

        <div class="itemModal">
          🎥 Permitir el uso de cámara y micrófono en tu navegador.
        </div>

        <div class="itemModal">
          🌐 Usar Google Chrome como navegador.
        </div>

      </div>

      <p class="descripcionModal">

        Por favor considera que
        <strong>la videollamada no funcionará</strong>
        en caso de:

      </p>

      <div class="listaModal">

        <div class="itemModal">

          🚫 Hacer uso de equipos corporativos que usen VPN
          o cuenten con bloqueos de seguridad de video/audio.

        </div>

      </div>

      <div class="footerModal">

        <div class="checkModal">

          <input
            class="form-check-input"
            type="checkbox"
            id="aceptar"
            [(ngModel)]="aceptoInstrucciones">

          <label for="aceptar">

            No volver a mostrar este mensaje.

          </label>

        </div>

        <button
          class="btnContinuar"
          type="button"
          (click)="continuarVideollamada()">

          Continuar

        </button>

      </div>

    </div>

  </div>

</ng-template>